import { ChamberMemberProPagePermissionsEnum } from "../../../graphql/types";

export const canCreateCmpMemberApplication = (
  permissions?: ReadonlyArray<ChamberMemberProPagePermissionsEnum> | null
) =>
  (permissions || []).includes(
    ChamberMemberProPagePermissionsEnum.ChamberAdminMembersCreateMember
  );

export const canManageCmpMembers = (
  permissions?: ReadonlyArray<ChamberMemberProPagePermissionsEnum> | null
) =>
  (permissions || []).includes(
    ChamberMemberProPagePermissionsEnum.ChamberAdminMembersManageMember
  );

export const getUnverifiedCreatedInvoiceContinuationCopy = ({
  canManageMembers,
}: {
  canManageMembers: boolean;
}) =>
  canManageMembers
    ? "The member and the invoice are saved. We could not check if the invoice can be emailed, so Send Invoice is not shown here. Go to Members > Manage Members, open this member, and select Send Invoice."
    : "The member and the invoice are saved. We could not check if the invoice can be emailed. Ask a staff member who can use Manage Members to send it.";
